// extracted by mini-css-extract-plugin
export default {"info":"ProfileDocumentsFormInfoMessage_info--Gwt","infoText":"ProfileDocumentsFormInfoMessage_infoText--PA2"};